/**
 * useSystemClientId
 *
 * React hook to fetch the system-level client ID from the backend (usually the 'guild' client).
 * Returns the system client ID as a number (or undefined if not available),
 * along with loading and error state from the Apollo query.
 *
 * Usage:
 *   const { systemClientId, loading, error } = useSystemClientId();
 */
import { useQuery } from '@apollo/client';
import { SYSTEM_CLIENT_ID } from '@src/graphql/queries/client';
export const useSystemClientId = () => {
    const { data, loading, error } = useQuery(SYSTEM_CLIENT_ID);
    const idRaw = data?.systemClientId;
    const parsed = Number(idRaw);
    const systemClientId = !isNaN(parsed) ? parsed : undefined;
    return {
        systemClientId,
        loading,
        error,
    };
};
